import { z } from 'zod';

/**
 * Languages the code panel can display, in tab order. C++, Python and JavaScript can be typed in
 * (ADR 0012); pseudocod sits last because it is only ever a translation of the program.
 */
export const CodeLanguage = z.enum(['cpp', 'py', 'js', 'pseudo']);
export type CodeLanguage = z.infer<typeof CodeLanguage>;

/** UI languages. Adding one means adding a Lingui catalog and a Blockly locale. */
export const UiLanguage = z.enum(['ro', 'en']);
export type UiLanguage = z.infer<typeof UiLanguage>;

/** Default code tab when an exercise does not pin one (plan §2). */
export function defaultCodeLanguage(ui: UiLanguage): CodeLanguage {
  return ui === 'ro' ? 'cpp' : 'js';
}

/**
 * The code tab to open (plan §2, v1.1): the project's remembered tab → the exercise's pinned
 * language → the student's "Code shown as" preference → the UI-language default.
 */
export function pickCodeLanguage(opts: {
  project?: CodeLanguage | null | undefined;
  exercise?: CodeLanguage | null | undefined;
  preference?: CodeLanguage | '' | null | undefined;
  ui: UiLanguage;
}): CodeLanguage {
  return opts.project || opts.exercise || opts.preference || defaultCodeLanguage(opts.ui);
}
